
import React, { useEffect, useState } from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import RouterConfig from './Router'
import { useDispatch } from 'react-redux'
import { authCheck, getPermissionTree, getRoleId, getSystemUsreInfo, Info } from './redux/action/Login'
import { setToken } from './redux/action/Components'
import { canViewUnclosed } from './redux/action/Stamp'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { InteractionStatus } from '@azure/msal-browser'
import { notification } from 'antd'
import { clearLoginInfo, isLoginExpired, LOGIN_EXPIRE_HOURS, markExpiredNotice, popExpiredNotice } from './helper/authSession'

// 超過登入有效時間：在第一次渲染前就清掉本地登入資料，直接進登入頁(不會先掛載選單去打 API 而跳錯誤)
if (isLoginExpired()) {
  clearLoginInfo()
  markExpiredNotice('expired')
}

function App() {
  const dispatch = useDispatch()
  const { accounts, instance, inProgress } = useMsal()
  const [user, setUser] =useState(JSON.parse(localStorage.getItem('userInfo')) || null)
  const [routeList, setRouteList] = useState(JSON.parse(localStorage.getItem('routeList')) || [])
  const [menuList, setMenuList] = useState(JSON.parse(localStorage.getItem('menuList')) || [])
  const [isLoad, setIsLoad] = useState(JSON.parse(sessionStorage.getItem('isLoad') || false))
  const [loading, setLoading] = useState(false)
  const [roleIds, setRoleIds] = useState(JSON.parse(localStorage.getItem('roleIds')) || [])
  const isAuthenticated = useIsAuthenticated()
  const token = useSelector(state => state.globalSetting.token)

  const SaveUserInfo = ({resUser, resRouteList, resMenuList, roleIds})=>{
    localStorage.setItem('refreshTime', JSON.stringify({ time : moment().add(LOGIN_EXPIRE_HOURS, 'hours').format('YYYY/MM/DD HH:mm:ss')}) )
    setUser(resUser) 
    localStorage.setItem('userInfo', `${JSON.stringify(resUser)}`)

    setRouteList(resRouteList)
    localStorage.setItem('routeList', `${JSON.stringify(resRouteList)}`)

    setMenuList(resMenuList)
    localStorage.setItem('menuList', `${JSON.stringify(resMenuList)}`)

    setRoleIds(roleIds)
    localStorage.setItem('roleIds', `${JSON.stringify(roleIds)}`)
  }

  // 登入逾時提醒
  useEffect(() =>{
    const reason = popExpiredNotice()
    if(reason){
      notification.info({
        message: '提示',
        description: reason === 'expired' ? `您已超過${LOGIN_EXPIRE_HOURS}小時未登出本系統，請重新登入!` : '登入已逾時，請重新登入!'
      })
    }
  }, [])

  useEffect(() =>{
    if(isAuthenticated && !token){
      const account = accounts[0]
      const accessTokenRequest = {
        scopes: ['user.read'],
        account: account
      }
      instance.acquireTokenSilent(accessTokenRequest).then((response) => {
        dispatch(setToken(response.accessToken))
      }).catch((e) => {
        instance.acquireTokenPopup(accessTokenRequest).then((response) => {
          dispatch(setToken(response.accessToken))
        })
      })
    }
  }, [isAuthenticated, token])


  //  檢查sso登入-> 檢查userInfo -> 跳轉管理頁面
  //                            -> 後端取userInfo -> 400跳轉註冊
  //                            -> 成功儲存localStorage
  //             ->跳登入畫面

  function getUserInfo(){ 
    dispatch(getSystemUsreInfo()).then((res) =>{
      if(res.data){
        dispatch(getRoleId()).then(roleIdResp =>{
          dispatch(canViewUnclosed()).catch(() => false).then(isViewer =>{
          // 檢視者(DB stampViewer)比照印信保管人，給最高用印權限(含待處理/用印審核/待上傳選單與路由)
          if(isViewer && roleIdResp < 3){ roleIdResp = 3 }
          // 存取層級(1一般員工 / 2主管 / 3財務·保管人)供 FinDoc 選單依角色顯示用
          localStorage.setItem('accessRoleId', roleIdResp)
          switch(roleIdResp){
            case 1:
              dispatch(getPermissionTree(["E04F01", "E04F02", "E04F05"])).then((resp) =>{
                if(resp.data.length !== 0){
                  localStorage.setItem('currentMenuItemsKey', 'StampApplication')
                  SaveUserInfo(
                    {
                      'resUser':{
                        'name':accounts[0].name,
                        'email':accounts[0].username
                      },
                      'resRouteList':[
                        {
                          'path':'/Stamp/StampApplyAdd',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyView/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewPendingUpload/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyReject/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyRejectAuditor/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyComplete/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyWithdraw/:id',
                          'element':'StampApplySignAndWithdraw',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplication',
                          'element': 'StampApplication',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampHistory',
                          'element': 'StampHistory',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingUpload',
                          'element': 'StampPendingUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampUnclosedTracking',
                          'element': 'StampUnclosedTracking',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampTempUpload/:id',
                          'element': 'StampTempUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCloseAudit/:id',
                          'element': 'StampCloseAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampOwnerAudit/:id',
                          'element': 'StampOwnerAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCancel/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplicationComplete/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        // {
                        //   'path': '/WFH/WFHApplication',
                        //   'element': 'WFHApplication',
                        //   'rolefunction':['']
                        // },
                        // {
                        //   'path': '/WFH/WFHApplication/:id',
                        //   'element': 'WFHApplicationDetail',
                        //   'rolefunction':['']
                        // }
                      ],
                      'resMenuList': resp.data[0],
                      'roleIds': res.data.roleIds
                    }
                  )
                  setLoading(false)
                }
              })
            break
            case 2:
              dispatch(getPermissionTree(["E04F01", "E04F02", "E04F03", "E04F04", "E04F05"])).then((resp) =>{
                if(resp.data.length !== 0){
                  localStorage.setItem('currentMenuItemsKey', 'StampApplication')
                  SaveUserInfo(
                    {
                      'resUser':{
                        'name':accounts[0].name,
                        'email':accounts[0].username
                      },
                      'resRouteList':[
                        {
                          'path':'/Stamp/StampApplyAdd',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyView/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewAudited/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewPendingUpload/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyReject/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyRejectAuditor/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyComplete/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplySign/:id',
                          'element':'StampApplySignAndWithdraw',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyWithdraw/:id',
                          'element':'StampApplySignAndWithdraw',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplication',
                          'element': 'StampApplication',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampHistory',
                          'element': 'StampHistory',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingAudit',
                          'element': 'StampPendingAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampAudited',
                          'element': 'StampAudited',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingUpload',
                          'element': 'StampPendingUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampUnclosedTracking',
                          'element': 'StampUnclosedTracking',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampTempUpload/:id',
                          'element': 'StampTempUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCloseAudit/:id',
                          'element': 'StampCloseAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampOwnerAudit/:id',
                          'element': 'StampOwnerAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCancel/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplicationComplete/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        }
                      ],
                      'resMenuList': resp.data[0],
                      'roleIds': res.data.roleIds
                    }
                  )
                  setLoading(false)
                }
              })
              break
            case 3:
              dispatch(getPermissionTree(["E04F01", "E04F02", "E04F03", "E04F04", "E04F05", "E04F06"])).then((resp) =>{
                if(resp.data.length !== 0){
                  localStorage.setItem('currentMenuItemsKey', 'StampApplication')
                  SaveUserInfo(
                    {
                      'resUser':{
                        'name':accounts[0].name,
                        'email':accounts[0].username
                      },
                      'resRouteList':[
                        {
                          'path':'/Stamp/StampApplyAdd',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyView/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewAudited/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewPendingUpload/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyViewPendingProcessed/:id',
                          'element':'StampApplyAddAndView',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyReject/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyRejectAuditor/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyComplete/:id',
                          'element':'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplyWithdraw/:id',
                          'element':'StampApplySignAndWithdraw',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplication',
                          'element': 'StampApplication',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampHistory',
                          'element': 'StampHistory',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampAudited',
                          'element': 'StampAudited',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingProcessed',
                          'element': 'StampPendingProcessed',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingUpload',
                          'element': 'StampPendingUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampUnclosedTracking',
                          'element': 'StampUnclosedTracking',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampTempUpload/:id',
                          'element': 'StampTempUpload',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCloseAudit/:id',
                          'element': 'StampCloseAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampOwnerAudit/:id',
                          'element': 'StampOwnerAudit',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampCancel/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampApplicationComplete/:id',
                          'element': 'StampApplyRejectAndComplete',
                          'rolefunction':['']
                        },
                        {
                          'path': '/Stamp/StampPendingAudit',
                          'element': 'StampPendingAudit',
                          'rolefunction':['']
                        },
                        {
                          'path':'/Stamp/StampApplySign/:id',
                          'element':'StampApplySignAndWithdraw',
                          'rolefunction':['']
                        },
                      ],
                      'resMenuList': resp.data[0],
                      'roleIds': res.data.roleIds
                    }
                  )
                  setLoading(false)
                }
              })
              break
            default:
              return
          }
          })
        })
      }
    })
  }

  useEffect(() => {
    if(isAuthenticated) {
      if(user === null){
        setLoading(true)
        sessionStorage.setItem('isLoad', true)
        getUserInfo()
      }
      else{
        setLoading(false)
      }
    }
    // 微軟登入已失效但本地仍留有使用者資料：清掉，回登入頁
    else if(user && inProgress === InteractionStatus.None){
      clearLoginInfo()
      notification.info({ message: '提示', description: '登入已逾時，請重新登入!' })
      setUser(null)
      setRouteList([])
      setMenuList([])
      setRoleIds([])
    }
  }, [isAuthenticated, user, inProgress])

  
  return(
    <div className="App">
      {RouterConfig(user, routeList, menuList, loading, roleIds)}
    </div>
  )

}

export default App;
